import React from 'react';
import {
    GridComponent,
    Inject,
    ColumnsDirective,
    ColumnDirective,
    Toolbar,
    Edit,
    Sort,
    Page,
} from '@syncfusion/ej2-react-grids';
import '../styles/grid.css';
import LoadingOverlay from './LoadingOverlay';

const DataGrid = ({
    data,
    columns,
    loading = false,
    toolbarOptions = [''],
    allowPaging = false,
    pageSettings = { pageSize: 10 },
    searchFields = [],
    onActionBegin,
    onActionComplete,
    rowHeight = 60,
    customClasses = '',
    enableHover = true,
    allowTextWrap = true,
    extraComponents,
    headerTemplate,
    actionButtons,
    editing = { allowDeleting: false, allowEditing: false, mode: 'Dialog' },
    gridLines = 'Both',
    onSearch,
}) => {
    // Default header template if not provided
    const defaultHeaderTemplate = (props) => (
        <div className="text-sm font-semibold text-gray-700 dark:text-gray-300">
            {props.headerText}
        </div>
    );

    return (
        <div className={`grid-container bg-white dark:bg-gray-800 rounded-lg shadow-enhanced p-4 ${customClasses}`}>

            {
                onSearch && (
                    <div className="mb-4">
                        <input
                            type="text"
                            placeholder="Rechercher..."
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    onSearch(e.target.value);
                                }
                            }}
                        />
                    </div>
                )
            }

            <GridComponent
                id={Math.random().toString(36).substr(2, 9)} // Unique ID for the grid
                dataSource={data}
                allowPaging={allowPaging}
                pageSettings={pageSettings}
                allowSorting={true}
                toolbar={toolbarOptions}
                searchSettings={{ fields: searchFields }}
                actionBegin={onActionBegin}
                actionComplete={onActionComplete}
                onSearch={onSearch}
                rowHeight={rowHeight}
                gridLines={gridLines}
                enableHover={enableHover}
                allowTextWrap={allowTextWrap}
                editSettings={editing}
                className="custom-grid"
                cssClass="custom-grid-style"
            >
                <ColumnsDirective>
                    {columns.map((column, index) => (
                        <ColumnDirective
                            key={index}
                            {...column}
                            headerTemplate={column.headerTemplate || headerTemplate || defaultHeaderTemplate}
                            headerTextAlign="center"
                            textAlign={column.textAlign || "center"}
                            width={column.width || "auto"}
                            allowSorting={column.allowSorting !== false}
                        />
                    ))}
                    {actionButtons && (
                        <ColumnDirective
                            headerText="Actions"
                            width="100"
                            textAlign="Center"
                            template={actionButtons}
                        />
                    )}
                </ColumnsDirective>
                <Inject services={[Edit, Sort, Toolbar, Page]} />
            </GridComponent>

            {extraComponents && (
                <div className="mt-4">
                    {extraComponents}
                </div>
            )}

            <LoadingOverlay loading={loading} />
        </div>
    );
};

export default DataGrid;